import axios from 'axios';
import { backendUrl, adminSecret } from 'src/app-globals';

const secret = window.btoa(adminSecret);
const instance = axios.create({
    baseURL: `${backendUrl}/admin`,
    withCredentials: true,
    headers: {
      'x-admin-secret': secret,
    },
});

export default instance;
